<template>
	<div class="wrapper">
		<!-- <el-row :gutter="24"> -->
		<!-- <el-col :span="24"> -->
		<!-- <el-page-header style="background-color: #FFFFFF00;" @back="goBack" :content="meetingName">
				</el-page-header> -->
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="债权人列表" name="first" v-if="userInfo.type !== 'MANAGER'" >
				<div class="tab-header meeting-search">
					<el-form :inline="true" :model="creatorForm" class="demo-form-inline">
						<div class="flex align-center justify-between">
							<div class="">
								<el-form-item label="关键字" label-width="73px">
									<el-input @change="monitor" style="width: 300px;" v-model.trim="creatorForm.keyword"
										placeholder="请输入关键字" clearable>
									</el-input>
								</el-form-item>
								<el-form-item>
									<el-button style="background-color: #F2F3F7;margin-right: 5px;"
										icon="el-icon-zhongzhishaixuan" :style="resetStyle()" :disabled="resetDisabled"
										@click="reset()">重置</el-button>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="onSearch">查询
									</el-button>
								</el-form-item>
							</div>
							<div class="">
								<el-form-item>
									<el-button icon="el-icon-plus" @click="addCreatorUser">
										添加</el-button>
								</el-form-item>
								<el-form-item>
									<el-button icon="el-icon-download">
										<a href="/xlxs/债权人信息导入模板(填写前仔细阅读表头填写规则).xls" style="color:#282D30;">下载导入模板</a>
									</el-button>
								</el-form-item>
								<el-form-item>
									<el-button icon="el-icon-daoru" @click="uploadDialogVisible = true">导入
									</el-button>
								</el-form-item>
								<el-form-item>
									<el-button icon="el-icon-daochu" @click="creditorListExportClick">导出
									</el-button>
								</el-form-item>
								<el-form-item>
									<div class="" style="font-size: 12px;">
										<Progress :isShow="isShow" :percentage="percentage" />
									</div>
								</el-form-item>
							</div>

						</div>


						<!-- <el-form-item label="债权人性质">
                                    <el-select v-model="creatorForm.creditorType" placeholder="请选择" clearable>
                                        <el-option v-for="item in creditorNature" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item> -->
					</el-form>

					<!-- <div class="operation">
                                <el-button type="primary" @click="onSearch" >查询
                                </el-button>
                                <el-button type="primary" @click="addCreatorUser" >
                                    添加</el-button>
                                <el-button type="primary" >
                                    <a href="/xlxs/债权人信息导入表的副本.xls" style="color:#fff;">下载导入模板</a>
                                </el-button>
                                <el-button type="primary" 
                                    @click="uploadDialogVisible = true">导入</el-button>
                                <Progress :isShow="isShow" :percentage="percentage" />
                            </div> -->
				</div>
				<el-row class="table-meeing">
					<el-table :data="tableData" v-loading="loading" size="medium" height="47.4vh"
						@selection-change="handleSelectionChange" ref="multipleTable">
						<el-table-column type="selection" width="50" align="center"> </el-table-column>
						<el-table-column prop="num" label="序号" width="80" align="center"></el-table-column>
						<el-table-column prop="subject" label="案号" min-width="160" align="center">
							<template slot-scope="scope">
								{{ scope.row.subject ? scope.row.subject : '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="name" label="债权人" min-width="140" align="center">
							<template slot-scope="scope">
								{{ scope.row.name ? scope.row.name : '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="phone" label="债权人手机号" min-width="140" align="center">
							<template slot-scope="scope">
								{{ scope.row.phone ? scope.row.phone : '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="idNumber" label="债权人证件号" min-width="170" align="center">
							<template slot-scope="scope">
								{{ scope.row.idNumber ? scope.row.idNumber : '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="username" label="债权人账号" min-width="170" align="center">
							<template slot-scope="scope">
								{{ scope.row.username ? scope.row.username : '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="cypher" label="债权人密码" min-width="140" align="center">
							<template slot-scope="scope">
								{{ scope.row.cypher ? scope.row.cypher : '无' }}
							</template>
						</el-table-column>
						<!-- <el-table-column prop="agentName" label="债权人性质" align="center" width="100"></el-table-column> -->
						<el-table-column prop="creditorType" label="债权人性质" align="center" min-width="100">
							<template slot-scope="scope">
								{{ scope.row.creditorType == 'PERSON' ? '个人' : '企业' }}
							</template>
						</el-table-column>
						<el-table-column prop="agentName" label="代理人" align="center" min-width="100">
							<template slot-scope="scope">
								{{ scope.row.agentName || '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="agentPhone" label="代理人手机" min-width="140" align="center">
							<template slot-scope="scope">
								{{ scope.row.agentPhone || '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="agentIdNumber" label="代理人证件号" min-width="170" align="center">
							<template slot-scope="scope">
								{{ scope.row.agentIdNumber || '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="agentUsername" label="代理人账号" min-width="170" align="center">
							<template slot-scope="scope">
								{{ scope.row.agentUsername || '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="agentCypher" label="代理人密码" align="center" min-width="100">
							<template slot-scope="scope">
								{{ scope.row.agentCypher || '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="debtorName" align="center" min-width="140" label="债务人企业">
							<template slot-scope="scope">
								{{ scope.row.debtorName || '无' }}
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" align="center" width="100px">
							<template slot-scope="scope">
								<el-button size="mini" type="text" style="color:#2766FF;"
									@click="editCreatorUser(scope.row)">编辑</el-button>
								<el-button icon="el-icon-delete" size="medium"
									type="text" style="color:#2766FF;" @click="deleteCreatorUser(scope.row.id)">
								</el-button>
								<el-button icon="el-icon-duanxin" size="medium" type="text" style="color:#2766FF;"
									@click="sendMsg(scope.row)"></el-button>
							</template>
						</el-table-column>
					</el-table>
					<Pagination :total="total" @handleSizeChange="turnPage" @handleCurrentChange="turnPage">
						<template v-slot:operation>
							<div style="text-align:left">
								<el-button style="border-color: #2766FF;color: #2766FF;"
									@click="deleteAll">批量删除</el-button>
								<el-button style="border-color: #2766FF;color: #2766FF;" @click="toggleSelection">取消选择
								</el-button>
							</div>
						</template>
					</Pagination>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="代理人列表" name="fourth">
				<div class="tab-header meeting-search">
					<el-form :inline="true" class="demo-form-inline">
						<div class="flex align-center justify-between">
							<div class="">
								<el-form-item label="关键字" label-width="73px">
									<el-input @change="monitor" style="width: 300px;" v-model.trim="creatorForm.keyword"
										placeholder="请输入关键字" clearable>
									</el-input>
								</el-form-item>
								<el-form-item>
									<el-button style="background-color: #F2F3F7;margin-right: 5px;"
										icon="el-icon-zhongzhishaixuan" :style="resetStyle()" :disabled="resetDisabled"
										@click="reset()">重置</el-button>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="onSearch">查询
									</el-button>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>
				<el-table :data="tableData" v-loading="loading" size="medium" height="47.4vh"
					ref="agentTable">
					<el-table-column prop="name" label="姓名/名称" align="center">
						<template slot-scope="scope">
							{{ scope.row.name ? scope.row.name : '无' }}
						</template>
					</el-table-column>
					<el-table-column prop="idNumber" label="证件号" align="center">
						<template slot-scope="scope">
							{{ scope.row.idNumber ? scope.row.idNumber : '无' }}
						</template>
					</el-table-column>
					<el-table-column prop="phone" label="手机号" align="center">
						<template slot-scope="scope">
							{{ scope.row.phone ? scope.row.phone : '无' }}
						</template>
					</el-table-column>
					<el-table-column prop="username" label="账号" align="center">
						<template slot-scope="scope">
							{{ scope.row.username ? scope.row.username : '无' }}
						</template>
					</el-table-column>
					<el-table-column prop="cypher" label="密码" align="center">
						<template slot-scope="scope">
							{{ scope.row.cypher ? scope.row.cypher : '无' }}
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" v-if="userInfo.type !== 'MANAGER'">
						<template slot-scope="scope">
							<el-button size="mini" type="text" style="color:#2766FF;"
								@click="editAgentStaffForm(scope.row)">编辑</el-button>
							<el-button icon="el-icon-duanxin" size="medium" type="text" style="color:#2766FF;"
								@click="sendMsg(scope.row)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				<Pagination :total="total" @handleSizeChange="turnPage" @handleCurrentChange="turnPage">
					<template v-slot:operation>
						<div style="text-align:left">
						</div>
					</template>
				</Pagination>
			</el-tab-pane>
			<el-tab-pane label="管理人列表" name="second">
				<el-table :data="tableData" v-loading="loading" size="medium" height="61vh"
					@selection-change="handleSelectionChange" ref="multipleTables">
					<el-table-column prop="name" label="姓名/名称" align="center">
						<template slot-scope="scope">
							{{ scope.row.name ? scope.row.name : '无' }}
						</template>
					</el-table-column>
					<el-table-column prop="username" label="证件号码" align="center">
						<template slot-scope="scope">
							{{ scope.row.username ? scope.row.username : '无' }}
						</template>
					</el-table-column>
					<el-table-column prop="cypher" label="密码" align="center">
						<template slot-scope="scope">
							{{ scope.row.cypher ? scope.row.cypher : '无' }}
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" v-if="userInfo.type !== 'MANAGER'">
						<template slot-scope="scope">
							<el-button size="mini" type="text" style="color:#2766FF;" @click="sendMsg(scope.row)">发送短信
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="其他人列表" name="third">
				<div class="tab-header meeting-search">
					<el-form :inline="true" class="demo-form-inline">
						<div class="flex align-center justify-between">
							<div class="">
								<el-form-item label="关键字" label-width="73px">
									<el-input @change="monitor" style="width: 300px;" v-model.trim="creatorForm.keyword"
										placeholder="请输入关键字" clearable>
									</el-input>
								</el-form-item>
								<el-form-item>
									<el-button style="background-color: #F2F3F7;margin-right: 5px;"
										icon="el-icon-zhongzhishaixuan" :style="resetStyle()" :disabled="resetDisabled"
										@click="reset()">重置</el-button>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="onSearch">查询
									</el-button>
								</el-form-item>
							</div>
							<div class="">
								<el-form-item  v-if="userInfo.type !== 'MANAGER'">
									<el-button icon="el-icon-plus" @click="addOtherStaff">
										添加</el-button>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>
				<el-table :data="tableData" v-loading="loading" size="medium" height="47.4vh"
					@selection-change="handleSelectionChange" ref="multipleTabless">
					<!-- <el-table-column type="selection" width="50" align="center"> </el-table-column> -->
					<el-table-column prop="name" label="姓名/名称" align="center">
						<template slot-scope="scope">
							{{ scope.row.name ? scope.row.name : '无' }}
						</template>
					</el-table-column>
					<el-table-column prop="phone" label="手机号" align="center">
						<template slot-scope="scope">
							{{ scope.row.phone ? scope.row.phone : '无' }}
						</template>
					</el-table-column>
					<el-table-column prop="username" label="账号" align="center">
						<template slot-scope="scope">
							{{ scope.row.username ? scope.row.username : '无' }}
						</template>
					</el-table-column>
					<el-table-column prop="cypher" label="密码" align="center">
						<template slot-scope="scope">
							{{ scope.row.cypher ? scope.row.cypher : '无' }}
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" v-if="userInfo.type !== 'MANAGER'">
						<template slot-scope="scope">
							<el-button size="mini" type="text" style="color:#2766FF;"
								@click="editOtherStaffForm(scope.row)">编辑</el-button>

							<el-button icon="el-icon-delete" size="medium" type="text"
								style="color:#2766FF;" @click="deleteCreatorUserss(scope.row.id)">
							</el-button>

							<el-button icon="el-icon-duanxin" size="medium" type="text" style="color:#2766FF;"
								@click="sendMsg(scope.row)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				
				<Pagination :total="total" @handleSizeChange="turnPage" @handleCurrentChange="turnPage">
					<template v-slot:operation>
						<div style="text-align:left">
						</div>
					</template>
				</Pagination>
			</el-tab-pane>
			<!-- <el-tab-pane label="直播人列表" name="third">
				<div class="tab-header meeting-search">
					<el-form :inline="true" :model="creatorForm" class="demo-form-inline">
						<div class="flex align-center">
							<el-form-item label="关键字" label-width="73px">
								<el-input @change="monitor" style="width: 731px;" v-model.trim="creatorForm.keyword"
									placeholder="请输入关键字" clearable>
								</el-input>
							</el-form-item>
							<el-form-item>
								<el-button style="background-color: #F2F3F7;margin-right: 5px;"
									icon="el-icon-zhongzhishaixuan" :style="resetStyle()" :disabled="resetDisabled"
									@click="reset()">重置</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" @click="onSearch">查询
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-button icon="el-icon-plus" @click="addstreamer">
									添加直播人</el-button>
							</el-form-item>
							
						</div>
					</el-form>
				</div>
				<el-row class="table-meeing">
					<el-table :data="tableData" v-loading="loading" size="medium" height="47.4vh"
						@selection-change="handleSelectionChange" ref="multipleTable">
						<el-table-column type="selection" width="50" align="center"> </el-table-column>
						<el-table-column prop="num" label="序号" width="80" align="center"></el-table-column>
						<el-table-column prop="subject" label="案号" min-width="160" align="center">
							<template slot-scope="scope">
								{{ scope.row.subject ? scope.row.subject : '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="name" label="直播人" min-width="140" align="center">
							<template slot-scope="scope">
								{{ scope.row.name ? scope.row.name : '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="phone" label="直播人手机号" min-width="140" align="center">
							<template slot-scope="scope">
								{{ scope.row.phone ? scope.row.phone : '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="username" label="直播人证件号" min-width="170" align="center">
							<template slot-scope="scope">
								{{ scope.row.username ? scope.row.username : '无' }}
							</template>
						</el-table-column>
						<el-table-column prop="cypher" label="直播人密码" min-width="140" align="center">
							<template slot-scope="scope">
								{{ scope.row.cypher ? scope.row.cypher : '无' }}
							</template>
						</el-table-column>
						
						<el-table-column fixed="right" label="操作" align="center" width="100px">
							<template slot-scope="scope">
								<el-button size="mini" type="text" style="color:#2766FF;"
									@click="editCreatorUsers(scope.row)">编辑</el-button>
								<el-button icon="el-icon-delete" v-if="previousTab !== 'fourth'" size="medium"
									type="text" style="color:#2766FF;" @click="deleteCreatorUsers(scope.row.id)">
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<Pagination :total="total" @handleSizeChange="turnPage" @handleCurrentChange="turnPage">
						<template v-slot:operation>
							<div style="text-align:left">
								<el-button style="border-color: #2766FF;color: #2766FF;" v-if="previousTab !== 'fourth'"
									@click="deleteAlls">批量删除</el-button>
								<el-button style="border-color: #2766FF;color: #2766FF;" @click="toggleSelection">取消选择
								</el-button>
							</div>
						</template>
					</Pagination>
				</el-row>
			</el-tab-pane> -->
		</el-tabs>
		<!-- </el-col> -->
		<!-- </el-row> -->
		<!-- 发送短信 -->
		<el-dialog title="发送短信" :visible.sync="batchDialogVisible" width="910px" :center="false" custom-class="sendMsg"
			top="12vh">
			<!-- <el-card shadow="never"> -->
			<div class="card-select">
				<div class="flex align-center">
					<span>手机号</span>
					<el-input v-model="phoneNumber" placeholder="请输入手机号"></el-input>
					<div v-if="rowData.agentId" class="flex align-center" style="margin-left: 30px;">
						<div class="" style="font-size: 14px;color: #282D30;margin-top: -4px;">
							接受方：
						</div>
						<el-radio-group style="margin-left: 5px;" :disabled="!rowData.agentId" v-model="userType">
							<el-radio label="">债权人</el-radio>
							<el-radio label="agent">代理人</el-radio>
						</el-radio-group>
					</div>
				</div>



			</div>

			<!-- </el-card> -->
			<el-table :data="tableMsgData" size="medium" class="batchDialog" height="420px"
				:header-row-style="{height:'20px'}">
				<el-table-column label="单选" width="65" align="center">
					<template slot-scope="scope">
						<el-radio :label="scope.row.choice" v-model="templateRadio"
							@change.native="getTemplateRow(scope.$index, scope.row)">&nbsp;</el-radio>
					</template>
				</el-table-column>
				<el-table-column width="140px" prop="name" label="短信名" align="center"></el-table-column>
				<el-table-column prop="content" label="模板内容"> </el-table-column>
			</el-table>
			<div class="flex align-center justify-center" style="margin-top: 20px;padding-bottom: 20px;">
				<div class="flex align-center">
					<span slot="footer" class="dialog-footer">
						<el-button style="width: 120px;" @click="batchDialogVisible = false">取 消</el-button>
						<!-- style="background:#de4d2a !important" -->
						<el-button style="width: 120px;" type="primary" @click="sendTemplateMsg" :loading="btnLoading">
							发送短信</el-button>
					</span>
				</div>
			</div>


		</el-dialog>
		<el-dialog :title="otherStaffDialogTitle" width="460px"
			:visible.sync="otherStaffsDialogVisible" :center="false" custom-class="sendMsg" @close="closeOtherStaffForm">
			<el-form :key="staffEditTarget + '-' + otherStaffFormType" :model="otherStaffForm" status-icon
				ref="ruleFormss" :rules="otherStaffFormRules" label-width="120px" class="demo-ruleForm"
				label-position="left">
				<el-form-item label="名称" prop="name">
					<el-input type="text" v-model="otherStaffForm.name" autocomplete="off"
						placeholder="请输入名称"></el-input>
				</el-form-item>
				<el-form-item v-if="staffEditTarget === 'agent'" label="证件号" prop="idNumber">
					<el-input type="text" v-model="otherStaffForm.idNumber" autocomplete="off"
						placeholder="请输入证件号"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone">
					<el-input type="text" v-model="otherStaffForm.phone" autocomplete="off"
						placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item v-if="otherStaffFormType == 'edit'" label="密码" prop="cypher">
					<el-input type="text" v-model="otherStaffForm.cypher" autocomplete="off"
						placeholder="请输入密码"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<!-- type="primary"  -->
				<el-button style="width: 120px;" @click="closeOtherStaffForm" plain>取消</el-button>
				<!-- style="background:#de4d2a !important" -->
				<el-button style="width: 120px;" type="primary" @click="addotherStaffForm()"
					:loading="loading">确定</el-button>
			</span>
		</el-dialog>
		<!-- 上传组件 -->
		<UploadFile :uploadDialogVisible="uploadDialogVisible" @cancel="cancel" @sureUpload="sureUpload"
			:isFileCheck="false" :isAccept="true" />
		<!-- 创建/编辑债权人 -->
		<CreditorDialog :creditorDialogVisible="creditorDialogVisible" :creditorForm="creditorForm" :isEdit="isEdit"
			:isType="false" :userId="userId" :isKey="true" :meetingId="meetingId" @cancel="cancelDialog"
			@refreshList="getCreatorUserList" />
		<!-- 创建/编辑直播人 -->
		<StreamerDialog :creditorDialogVisible="streamerDialogVisible" :creditorForm="streamerForm" :isEdit="isEdit"
			:isType="false" :userId="userId" :isKey="true" :meetingId="meetingId" @cancel="cancelDialog"
			@refreshList="getCreatorUserList" />

	</div>
</template>

<script>
	import global from 'global';
	import bus from '@/utils/bus';
	import Pagination from '@/components/Pagination';
	import CreditorDialog from '@/components/creditorDialog';
	import StreamerDialog from '@/components/streamerDialog';
	import UploadFile from '@/components/uploadFile';
	import Progress from '@/components/progress';
	import {
		mapState
	} from 'vuex';
	import {
		getUserList,
		getCreatorUserList,
		deleteCreatorUser,
		getCreatorCount,
		importCreatorUser,
		importProgress,
		creditorListExport,
		editOther,
		editAgent,
		delOther,
		addOther,
	} from '@/serve/user';
	import {
		getStreamerList,
		getStreamerListCount,
		addStreamerList,
		editStreamerList,
		addsStreamerList,
	} from '@/serve/streamerList';
	import {
		setTimeout,
		clearTimeout,
		clearInterval
	} from 'timers';
	import {
		getSmsList,
		singleSMS,
		getMeetingManager,
		getMeetingLianluMsg,
		singleSend
	} from '@/serve/sms';
	export default {
		components: {
			Pagination,
			CreditorDialog,
			UploadFile,
			Progress,
			StreamerDialog
		},
		props: {
			meetingId: String,
			peopleManagementActiveName: String,
		},
		created() {
			// let flag = +this.$route.query.num;
			// this.meetingName = this.$route.query.name;
			// this.meetingId = this.$route.query.id;
			// this.previousTab = this.$route.query.tab;
			// flag ? (this.isFlag = true) : (this.isFlag = false);
			if(this.userInfo.type == 'MANAGER'){
				this.getMeetingManager();
			}else{
				this.getCreatorUserList();
			}
		},
		computed: {
			...mapState({
				userInfo: (state) => state.user.userInfo
			}),
			otherStaffDialogTitle() {
				if (this.staffEditTarget === 'agent') {
					return '编辑代理人';
				}
				return this.otherStaffFormType == 'edit' ? '编辑其他人员' : '添加其他人员';
			},
			otherStaffFormRules() {
				const rules = {
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
				};
				if (this.staffEditTarget === 'agent') {
					rules.phone = [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}];
				}
				if (this.otherStaffFormType == 'edit') {
					rules.cypher = [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}];
				}
				return rules;
			},
		},
		watch: {
			isFinish(newVal, oldVal) {
				if (newVal) {
					this.percentage = 100;
					clearTimeout(this.timer);
					this.$message.success('文件上传完毕');
					this.isShow = false;
					this.getCreatorUserList();
				}
			},
			peopleManagementActiveName(newVal, oldVal) {
				if(this.userInfo.type === 'MANAGER'){
					if (newVal === 'first') {
						this.activeName = 'second';
					}else{
						this.activeName = newVal;
					}
				}else{
					if (newVal === 'first') {
						console.log("jin");
						this.activeName = 'first';
						// this.getSmsList();
					}
				}
			}
		},
		methods: {
			closeOtherStaffForm(){
				console.log("jin")
				this.$refs['ruleFormss'].resetFields();
				this.otherStaffsDialogVisible = false;
				this.staffEditTarget = 'other';
			},
			editOtherStaffForm(row) {
				this.staffEditTarget = 'other';
				this.otherStaffFormType = 'edit';
				this.otherStaffForm = JSON.parse(JSON.stringify(row));
				this.otherStaffsDialogVisible = true;
				console.log("row", row);
			},
			editAgentStaffForm(row) {
				this.staffEditTarget = 'agent';
				this.otherStaffFormType = 'edit';
				this.otherStaffForm = JSON.parse(JSON.stringify(row));
				this.otherStaffsDialogVisible = true;
			},
			addotherStaffForm() {
				this.$refs['ruleFormss'].validate((valid) => {
					if (valid) {
						if (this.otherStaffFormType == 'add') {
							addOther(this.meetingId, this.otherStaffForm)
								.then(() => {
									this.$message.success('创建成功');
									this.getCreatorUserList();
									this.otherStaffsDialogVisible = false;
									this.otherStaffFormType = '';
								})
								.catch(err => {
									this.$message.error(err.data.message);
								});
						} else if (this.otherStaffFormType == 'edit') {
							const editRequest = this.staffEditTarget === 'agent'
								? editAgent(this.meetingId, this.otherStaffForm.id, this.otherStaffForm)
								: editOther(this.meetingId, this.otherStaffForm.id, this.otherStaffForm);
							editRequest
								.then(() => {
									this.$message.success('编辑成功');
									this.getCreatorUserList();
									this.otherStaffsDialogVisible = false;
									this.otherStaffFormType = '';
									this.staffEditTarget = 'other';
								})
								.catch(err => {
									this.$message.error(err.data.message);
								});
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			creditorListExportClick() {
				let token = sessionStorage.getItem('ms_token');
				let url =
					`/api/gathering/meeting/${this.meetingId}/invitee/list/info/export?keyword=${this.creatorForm.keyword}&attend=true&page=0&rows=${this.total}&access_token=${token}`;
				console.log("url", url)
				this.createLabel(url);
			},
			createLabel(url) {
				const a = document.createElement('a');
				a.setAttribute('href', url);
				a.setAttribute('download', '债权人列表');
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			addstreamer() {
				this.streamerForm = {
					admin: false,
					attend: false,
					livePresenter: true,
					creditorType: '',
					debtorName: '',
					name: '',
					phone: '',
					remark: '',
					username: '',
					type: 'LIVE_PRESENTER',
					page: 0,
					rows: 20
				};
				this.streamerDialogVisible = true;
			},
			monitor(e) {
				if (this.creatorForm.keyword != '') {
					this.resetDisabled = false;
				} else {
					this.resetDisabled = true;
				}
			},
			resetStyle() {
				let type = false;
				if (this.creatorForm.keyword != '' && this.creatorForm.keyword != null) {
					type = true;
				}
				let color = type ? "#282D30" : "rgba(0,0,0,0.4)"
				return {
					color: color
				}
			},
			// 按当前 tab 同步列表查询参数，避免切换 tab 后 agent 等参数残留
			syncCreatorFormForActiveTab(tabName) {
				const tab = tabName || this.activeName;
				if (tab === 'first') {
					this.creatorForm.admin = false;
					this.creatorForm.attend = true;
					this.creatorForm.agent = false;
					this.creatorForm.livePresenter = '';
				} else if (tab === 'third') {
					this.creatorForm.admin = false;
					this.creatorForm.attend = false;
					this.creatorForm.agent = false;
				} else if (tab === 'fourth') {
					this.creatorForm.admin = false;
					this.creatorForm.attend = false;
					this.creatorForm.agent = true;
				}
			},
			handleClick(tab) {
				console.log("tab", tab);
				this.resetDisabled = true;
				this.creatorForm.keyword = '';
				this.tableData = [];
				if (tab.name === 'second') {
					this.getMeetingManager();
				} else if (tab.name === 'first' || tab.name === 'third' || tab.name === 'fourth') {
					this.activeName = tab.name;
					this.syncCreatorFormForActiveTab(tab.name);
					this.creatorForm.page = 0;
					this.creatorForm.rows = 20;
					this.getCreatorUserList(tab.name);
				}
			},
			// 获取会议管理人
			getMeetingManager() {
				this.creatorForm = {
					admin: true,
					attend: false,
					creditorType: '',
					debtorName: '',
					name: '',
					phone: '',
					remark: '',
					username: '',
					page: 0,
					rows: 20
				};
				this.getCreatorUserList();
			},
			// 取消
			cancel() {
				this.uploadDialogVisible = false;
				this.uploadDialogVisible = false;
			},
			// 发送短信
			sendMsg(row) {
				this.rowData = row;
				this.userType = '';
				this.userId = row.id;
				this.batchDialogVisible = true;
				this.getSmsList();
			},
			// 搜索
			onSearch() {
				this.creatorForm.page = 0;
				this.creatorForm.rows = 20;
				this.getCreatorUserList();
			},
			reset() {
				this.creatorForm.keyword = '';
				this.resetDisabled = true;
				this.onSearch();
			},
			resetStyle() {
				let type = false;
				if (this.creatorForm.keyword != '') {
					type = true;
					this.resetDisabled = false;
				}
				let color = type ? "#282D30" : "rgba(0,0,0,0.4)"
				return {
					color: color
				}
			},
			// 获取短信模板
			getSmsList() {
				getMeetingLianluMsg(this.meetingId, {
						page: 0,
						rows: 100
					})
					.then(res => {
						for (let i = 0; i < res.length; i++) {
							res[i].choice = i;
						}
						this.tableMsgData = this.handleTableList(res);
						this.templateSelection = this.tableMsgData[this.templateRadio];
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
			},
			// 确认上传
			sureUpload(id) {
				bus.$emit('clear');
				this.uploadDialogVisible = false;
				this.isShow = true;
				importCreatorUser(this.meetingId, {
						fileId: id
					})
					.then(res => {
						
						this.progressId = res.id;
						this.fileProgressUpload(this.progressId);
					})
					.catch(err => {
						this.$message.error(err.data.message);
						this.isShow = false;
					});
			},
			// 文件进度接口
			fileProgressUpload(id) {
				importProgress(this.meetingId, id).then(res => {
					if(!res.success){
						if(res.failedList.length!='0'){
							this.$message.error(`${res.failedList.toString()},${res.errMessage}`);
						}else{
							this.$message.error(`${res.errMessage}`);
						}
						clearTimeout(this.timer);
						this.timer = null;
						this.isShow = false;
					}
					this.fileCount = res.count;
					this.isFinish = res.finished;
					if (res.total) {
						this.percentage = parseInt((100 * this.fileCount) / res.total);
					}
					this.timer = setTimeout(() => {
						this.fileProgressUpload(this.progressId);
					}, 500);
				});
			},
			// 单选模板信息
			getTemplateRow(index, row) {
				this.templateSelection = row;
			},
			// 发送信息
			sendTemplateMsg() {
				this.phoneNumber = this.phoneNumber.replace(/(^\s*)|(\s*$)/g, "")
				if (!this.phoneNumber.trim() || !/^1[3456789]\d{9}$/.test(this.phoneNumber)) {
					return this.$message.warning('请输入11位手机号');
				}
				this.btnLoading = true;
				const {
					agentId,
					userId
				} = this.rowData;
				console.log("templateRadio", this.templateRadio);
				singleSend(this.meetingId, {
						meeting_lianlu_msg_id: this.tableMsgData[this.templateRadio].id,
						phone: this.phoneNumber,
						userId: this.userType === 'agent' ? agentId : userId
					})
					.then(() => {
						this.$message.success('发送成功');
						this.btnLoading = this.batchDialogVisible = false;
						this.phoneNumber = '';
						this.templateRadio = 0;
					})
					.catch(err => {
						this.phoneNumber = '';
						this.templateRadio = 0;
						this.btnLoading = this.batchDialogVisible = false;
						this.$message.error(err.data.message);
					});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			turnPage(attr, val) {
				this.creatorForm[attr] = val;
				this.getCreatorUserList();
			},
			toggleSelection() {
				this.$refs.multipleTable.clearSelection();
				this.$refs.multipleTabless.clearSelection();
			},
			editCreatorUser(row) {
				this.userId = row.id;
				this.creditorDialogVisible = true;
				this.isEdit = true;
				this.creditorForm = {
					...row
				};
				// console.log('xxx', this.creditorForm, row);
			},
			editCreatorUsers(row) {
				console.log("row", row)
				console.log("meetingId", this.meetingId)
				this.userId = row.id;
				this.streamerDialogVisible = true;
				this.isEdit = true;
				this.streamerForm = {
					...row
				};
				// console.log('xxx', this.creditorForm, row);
			},
			deleteCreatorUser(ids) {
				typeof ids != 'object' ? (ids = [ids]) : '';
				this.$confirm('此操作将会把债权人移除该会议, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteCreatorUser(this.meetingId, {
							ids
						})
						.then(() => {
							this.$message.success('删除成功');
							this.getCreatorUserList();
						})
						.catch(err => {
							this.$message.error('删除失败');
						});
				});
			},
			deleteCreatorUsers(ids) {
				typeof ids != 'object' ? (ids = [ids]) : '';
				this.$confirm('此操作将会把直播人移除该会议, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteCreatorUser(this.meetingId, {
							ids
						})
						.then(() => {
							this.$message.success('删除成功');
							this.getCreatorUserList();
						})
						.catch(err => {
							this.$message.error('删除失败');
						});
				});
			},
			deleteCreatorUserss(ids) {
				typeof ids != 'object' ? (ids = [ids]) : '';
				this.$confirm('此操作将会把其他人员移除该会议, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delOther(this.meetingId,ids)
						.then(() => {
							this.$message.success('删除成功');
							this.getCreatorUserList();
						})
						.catch(err => {
							this.$message.error('删除失败');
						});
				});
			},
			cancelDialog() {
				this.creditorDialogVisible = false;
				this.isEdit = false;
				this.streamerDialogVisible = false;
			},
			addCreatorUser() {
				this.creditorDialogVisible = true;
				this.creditorForm = {
					admin: false,
					attend: true,
					creditorType: '',
					debtorName: '',
					name: '',
					phone: '',
					remark: '',
					username: '',
					type: 'CREDITOR',
					page: 0,
					rows: 20
				};
			},
			addOtherStaff() {
				this.staffEditTarget = 'other';
				this.otherStaffFormType = 'add';
				this.otherStaffsDialogVisible = true;
				this.otherStaffForm = {
					admin: false,
					attend: false,
					agent: false,
					name: '',
					phone: '',
				}
			},
			// 获取债权人列表；tabName 用于 tab 切换时避免 activeName 尚未更新导致参数错误
			async getCreatorUserList(tabName) {
				if (this.activeName !== 'second' || tabName) {
					this.syncCreatorFormForActiveTab(tabName);
				}
				this.loading = true;
				console.log("creatorForm", this.creatorForm);
				try {
					this.total = await getCreatorCount(this.meetingId, this.creatorForm);
					await this.getList();
				} catch (err) {
					this.loading = false;
					this.tableData = [];
					this.$message.error((err && err.data && err.data.message) || '获取列表失败');
				}
			},
			getList() {
				console.log("creatorForm", this.creatorForm);
				return getCreatorUserList(this.meetingId, this.creatorForm)
					.then(res => {
						this.loading = false;
						const list = res || [];
						for (let i = 0; i < list.length; i++) {
							list[i].num = i + 1;
						}
						this.tableData = this.handleTableList(list);
					})
					.catch(err => {
						this.loading = false;
						this.tableData = [];
						this.$message.error((err && err.data && err.data.message) || '获取列表失败');
						return Promise.reject(err);
					});
			},
			goBack() {
				this.$router.push({
					path: '/meetingManages',
					query: {
						tab: this.previousTab,
					}
				});
			},
			// 批量删除
			deleteAll() {
				if (!this.multipleSelection.length) {
					return this.$message.error('请先选中');
				}
				let ids = this.multipleSelection.map(item => item.id);
				this.deleteCreatorUser(ids);
			},
			// 批量删除
			deleteAlls() {
				if (!this.multipleSelection.length) {
					return this.$message.error('请先选中');
				}
				let ids = this.multipleSelection.map(item => item.id);
				this.deleteCreatorUsers(ids);
			},
			// 批量删除
			deleteAllss() {
				if (!this.multipleSelection.length) {
					return this.$message.error('请先选中');
				}
				let ids = this.multipleSelection.map(item => item.id);
				this.deleteCreatorUserss(ids);
			}
		},
		data() {
			return {
				rowData: {},
				userType: '',
				previousTab: '',
				meetingName: '',
				activeName: this.peopleManagementActiveName,
				timer: null,
				templateRadio: 0,
				percentage: 0,
				progressId: '',
				fileCount: -1,
				// meetingId: '',
				userId: '',
				btnLoading: false,
				loading: false,
				isFlag: false,
				isEdit: false,
				isShow: false,
				isFinish: false,
				total: 0,
				uploadDialogVisible: false,
				creditorDialogVisible: false,
				importDialogVisible: false,
				batchDialogVisible: false,
				otherStaffsDialogVisible: false,
				otherStaffFormType: '',
				staffEditTarget: 'other',
				otherStaffForm: {},
				templateSelection: {},
				multipleSelection: [],
				centerDialogVisible: false,
				options: [],
				creatorForm: {
					admin: false,
					attend: true,
					agent: false,
					livePresenter: '',
					creditorType: '',
					debtorName: '',
					name: '',
					phone: '',
					remark: '',
					username: '',
					page: 0,
					rows: 20,
					keyword: '',
				},
				creditorNature: [{
						label: '个人',
						value: 'PERSON'
					},
					{
						label: '企业',
						value: 'COMPANY'
					}
				],
				creditorForm: {
					admin: false,
					attend: true,
					creditorType: '',
					debtorName: '',
					name: '',
					phone: '',
					remark: '',
					username: '',
					cypher: '',
					type: 'CREDITOR',
					page: 0,
					rows: 20
				},
				ruleForm: {
					pass: '',
					checkPass: ''
				},
				value: '',
				tableData: [],
				tableMsgData: [],
				phoneNumber: '',
				resetDisabled: true,
				streamerForm: {

				},
				streamerDialogVisible: false,
			};
		}
	};
</script>
<style scoped lang="scss">
	::v-deep.el-dialog .el-table--medium th {
		padding: 5px 0px;
	}

	::v-deep.el-dialog .el-table th {
		padding: 5px 0px;
	}

	::v-deep .el-dialog__body {
		padding-top: 0px;
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 0px;
	}

	::v-deep .el-tabs__nav-scroll {
		padding-left: 15px;
		box-sizing: border-box;
	}

	.wrapper {
		height: auto;

		.pagination {
			.el-pagination {
				padding: 2px 15px;
			}
		}

		.el-page-header {
			background: #fff;
			padding: 15px;
		}

		.el-tabs {
			::v-deep .el-tabs__header {
				padding: 0 0px 10px 0px;
				box-sizing: border-box;
				margin: 0;
				background: #fff;
			}
		}

		.batchDialog {
			box-sizing: border-box;

			::v-deep .el-table__empty-block {
				width: 100% !important;
			}
		}

		.card-select {
			// text-align: center;
			margin: 20px 0;

			span {
				margin-right: 20px;
			}

			.el-input {
				width: 50%;
			}
		}

		::v-deep .el-dialog {
			.demo-ruleForm {
				margin-top: 20px;
			}

			.el-card {
				background: #eeeded;
			}

			::v-deep .el-dialog__header {
				padding-bottom: 0px;
			}

			::v-deep .el-dialog__body {
				padding: 0 20px;
			}

			::v-deep .el-form-item {
				width: 70%;
			}
		}

		::v-deep .demo-ruleForm {
			.el-form-item {
				width: 100%;
			}
		}

		.el-form-item {
			// width: 40%;

			::v-deep .el-form-item__content {
				// width: 70%;
			}
		}

		.tab-header {
			background: #fff;
			box-sizing: border-box;
			// padding: 20px 0;
			padding-top: 5px;
		}

		.table-meeing {
			// margin-top: 20px;

			.block {
				background: #fff;
				padding: 20px;
				display: flex;
				justify-content: space-between;
				align-content: center;
			}

			::v-deep .el-table__row .cell {
				// overflow: scroll;
				// white-space: nowrap;
				// text-overflow: ellipsis;
			}
		}

		.el-table ::v-deep .is-leaf {
			// background: #c22929 !important;
			// background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
			// background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
			// background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
			// background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
			// background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
			background: #fafbfd;
			color: rgba(25, 30, 36, 0.6);
		}

		.el-table .el-button ::v-deep span:hover {
			border-bottom: 1px solid #2766FF;
		}

		.operation {
			width: 100%;
			padding: 0 100px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			box-sizing: border-box;

			.el-progress {
				display: inline-block;
				width: 400px;
			}

			.el-link {
				margin: 0 10px 0 30px;
				font-size: 12px !important;
			}
		}
	}
</style>
<style lang="scss">
	.sendMsg {
		::v-deep .el-dialog__body {
			// padding: 0;

			::v-deep .el-table__header-wrapper {
				::v-deep .has-gutter ::v-deep .el-checkbox {
					display: none;
				}
			}
		}

		::v-deep .el-table__row td:nth-child(3) .cell {
			display: -webkit-box;
			-webkit-line-clamp: 3;
			overflow: hidden;
			text-overflow: ellipsis;
			-webkit-box-orient: vertical;
		}

		::v-deep .el-radio__inner {
			// border: 1px solid #c22929;
		}
	}
</style>